/**
 * App-side wiring for the favicon resolver in `@heidi/utils`.
 *
 * `getFaviconUrl` / `prefetchFavicons` resolve a cited domain's icon through
 * Google's favicon service, so every rendered citation would tell a third party
 * which source a clinician was shown. An appliance must not make that request —
 * and a package may not read the build profile to find out which build it is
 * (F5) — so the one fact crosses here.
 *
 * ON-PREM-GATE: the build predicate, not a bundle flag. This is an egress
 * decision about a third-party host (F2), and the on-prem CSP
 * (`config/csp/onprem-csp.js`, `img-src 'self' data: blob:`) refuses the host
 * regardless of how any flag resolves, so there is no posture for a flag to
 * choose between. With the lookup off the resolver hands back a bundled generic
 * icon (a `data:` URI) and no favicon request is issued at all, rather than
 * issued and blocked.
 *
 * The seam defaults OPEN, so forgetting this import costs nothing on cloud and
 * leaves on-prem relying on the CSP alone — an invisible failure, which is why
 * `favicon-wiring.test.ts` asserts the call rather than trusting it.
 *
 * Imported for effect at module scope from `_app.tsx`, beside
 * `answer-kit-wiring`, so it evaluates before any answer surface mounts.
 */
import { isOnPrem } from '@/utils/buildProfile';
import { configureFavicons } from '@heidi/utils';

configureFavicons({ remoteLookupEnabled: !isOnPrem });
